module.exports = __webpack_public_path__ + "static/media/x-white.bb7b59b1.svg";